import React from "react";
import PropTypes from "prop-types";

import { Paragraph, Title } from "@/components/atoms/Typography/styles";
import { SucessIcon, Wrapper } from "./styles";

function SuccessMessageDefault({ message, messageDescription }) {
  return (
    <Wrapper>
      <div>
        <SucessIcon />
        <Title>{message}</Title>
        <Paragraph>{messageDescription}</Paragraph>
      </div>
    </Wrapper>
  );
}

SuccessMessageDefault.propTypes = {
  message: PropTypes.string,
  messageDescription: PropTypes.string,
};

export default SuccessMessageDefault;
